export const BRANCH_PRODUCT_CATEGORY = 'Animals & Pet Supplies' as const;
export const BRANCH_CONTENT_SCHEMA_COMMERCE = 'COMMERCE_PRODUCT' as const;
